export default __webpack_public_path__ + "static/media/buddhi-tez.53e87614.jpg";